import classNames from 'classnames';
import React from 'react';
import './Overlay.scss';
import IOverlayProps from './OverlayProps';

const Overlay = ({ onClick, className, children }: IOverlayProps) => (
  <div className={classNames('overlay', className)} onClick={onClick}>
    {children}
  </div>
);

export default Overlay;
